module.exports = __webpack_public_path__ + "img/ps-43.e4e18d0a.jpg";